import $ from 'jquery'
import {disableTextSelection, enableTextSelectionBack, isEnterPressed, isEscapePressed} from '../atBrowserUtils'
import {trim} from '../atUtils'
import UserTime from '../user_time'

function WorkdayDurationsEditor() {}

WorkdayDurationsEditor.WEEK_LENGTH = 7;

WorkdayDurationsEditor.prototype.init = function( durations, weekStartDay, changesCallback, showHeader, invalidTooltipMessage, decimalSeparator, readOnly )
{
    this.weekStartDay = weekStartDay;
    this.value = durations;
    this.headTrEl = null;
    this.changesCallback = changesCallback;
    this.showHeader = showHeader;
    this.invalidTooltipMessage = invalidTooltipMessage;
    this._decimalSeparator = decimalSeparator;
    this.readOnly = readOnly;
    var self = this;

    this.inputs = [];
    for( var j = 0; j < WorkdayDurationsEditor.WEEK_LENGTH; j++  )
    {
        var input = document.createElement( "input" );
        input.type = "text";
        input.dayIdx = j;
        input.maxLength = 6;
        input.onblur = function()  { self.onBlur(this, readOnly);  };
        input.onfocus = function() { self.onFocus(this, readOnly); };
        input.onkeydown = function(e) {
            if (isEscapePressed(e) || isEnterPressed(e)) {
                this.blur()
                e.stopPropagation()
            }
        }

        this.inputs.push( input );
    }

    return this;
};

WorkdayDurationsEditor.prototype.setInvalidTooltipMessage = function( invalidTooltipMessage )
{
    this.invalidTooltipMessage = invalidTooltipMessage;
    for( var i = 0; i < this.inputs.length; i++ )
        if( this.inputs[i].title )
            this.inputs[i].title = invalidTooltipMessage;
};

WorkdayDurationsEditor.prototype.setWeekStartDay = function( weekStartDay )
{
    this.weekStartDay = weekStartDay;
};

WorkdayDurationsEditor.buildHeader = function( weekStartDay )
{
    var headerEl = document.createElement("tHead");
    headerEl.className = "wdEditorHeader";

    var headerTr = document.createElement("tr");
    headerEl.appendChild( headerTr );

    weekStartDay --;
    for( var j = 0; j < WorkdayDurationsEditor.WEEK_LENGTH; j++ )
    {
        var th = document.createElement( "th" );
        th.innerHTML = Date.dayNamesShort[weekStartDay];
        headerTr.appendChild( th );
        weekStartDay ++;
        if( weekStartDay == 7 )
            weekStartDay = 0;
    }

    return headerEl;
};

WorkdayDurationsEditor.buildTableHeader = function( weekStartDay )
{
    var tHead = document.createElement("thead");
    var tr = document.createElement("tr");
    tHead.appendChild( tr );
    tr.appendChild( document.createElement("th") );

    var daysTable = document.createElement("table");
    daysTable.cellPadding = 0;
    daysTable.cellSpacing = 0;
    daysTable.appendChild( this.buildHeader( weekStartDay ) );
    var th = document.createElement("th");
    th.appendChild( daysTable );
    tr.appendChild( th );


    tr.appendChild( document.createElement("th") );
    tr.appendChild( document.createElement("th") );

    th = document.createElement("th");
    th.className = "last";
    tr.appendChild( th );

    return tHead;
};

WorkdayDurationsEditor.prototype.renderTo = function( containerEl )
{
    var tableEl = document.createElement( "table" );
    var tBodyEl = document.createElement( "tbody" );

    var bodyTrEl = document.createElement( "tr" );

    if( this.showHeader )
    {
        var tHeadEl = WorkdayDurationsEditor.buildHeader( this.weekStartDay );
        this.headTrEl = tHeadEl.firstChild;
        tableEl.appendChild( tHeadEl );
    }

    tableEl.appendChild( tBodyEl );
    tBodyEl.appendChild( bodyTrEl );

    tableEl.cellPadding = 0;
    tableEl.cellSpacing = 0;
    tableEl.className = this.getTableClassName();

    var inputOffset = this.weekStartDay - 1;

    for( var i = 0; i < WorkdayDurationsEditor.WEEK_LENGTH; i++ )
    {
        var bodyTdEl = document.createElement( "td" );
        var cellInput = this.inputs[inputOffset];
        cellInput.cellIdx = i;
        bodyTdEl.appendChild( cellInput );
        bodyTrEl.appendChild( bodyTdEl );
        inputOffset = inputOffset == 6 ? 0 : inputOffset + 1;
    }

    this.updateUI();

    containerEl.appendChild( tableEl );
};

WorkdayDurationsEditor.prototype.getTableClassName = function( ) {
     return "wdEditor";
};

WorkdayDurationsEditor.prototype.addBorderClasses = function( td, className )
{
    $(td).addClass(className);
    var nextTd = td.nextSibling;
    if( nextTd )
        $(nextTd).addClass(className + "Left");
};

WorkdayDurationsEditor.prototype.removeBorderClasses = function( td, className )
{
    $(td).removeClass(className);
    var nextTd = td.nextSibling;
    if( nextTd )
        $(nextTd).removeClass(className + "Left");
};


WorkdayDurationsEditor.prototype.onFocus = function( input, readOnly )
{
    if (!readOnly)
        this.addBorderClasses( input.parentNode, "focus" );
};

WorkdayDurationsEditor.prototype.onBlur = function( input, readOnly )
{
    if (!readOnly) {
        input.value = trim(input.value);
        this.removeBorderClasses(input.parentNode, "focus");
        this.updateValueFromInput(input);
    }
};

WorkdayDurationsEditor.prototype.updateValueFromInput = function( input )
{
    var value = input.value.length == 0 ? 0 : UserTime.parseTimeWithSystemSettings( input.value, false, this._decimalSeparator );
    value = value<0 ? null : value;
    var valueChanged = this.value[ input.dayIdx ] != value;
    this.value[ input.dayIdx ] = value;
    this.updateUIForCell( input.dayIdx );
    if( input.parentNode.nextSibling )
        this.updateUIForCell( input.parentNode.nextSibling.firstChild.dayIdx );
    if( this.changesCallback && valueChanged )
        this.changesCallback( input.dayIdx, value, this.value );
};

WorkdayDurationsEditor.prototype.getDurations = function()
{
    return this.value;
};

WorkdayDurationsEditor.prototype.hasErrors = function()
{
    for( var i = 0; i < WorkdayDurationsEditor.WEEK_LENGTH; i++ )
        if( this.value[i] == null )
            return true;
    return false;
};


WorkdayDurationsEditor.prototype.setDurations = function( durations )
{
    this.value = durations;
};

WorkdayDurationsEditor.prototype.updateUI = function()
{
    for( var i = 0; i < WorkdayDurationsEditor.WEEK_LENGTH; i++ )
        this.updateUIForCell( i );
};

WorkdayDurationsEditor.prototype.updateUIForCell = function( dayIdx )
{
    var value = this.value[dayIdx];
    var input = this.inputs[dayIdx];
    var td = input.parentNode;
    var classes = [];

    if( !td.previousSibling )
        classes.push( "first" );

    if( !td.nextSibling )
        classes.push( "last" );

    if( value != null )
    {
        input.value = UserTime.formatTimeWithoutMinutesIfPossible( value );
        input.defaultValue = input.value;
        input.removeAttribute("title");
        if( value == 0 )
            classes.push("nonWorking");
    }
    else
    {
        classes.push( "error" );
        if( this.invalidTooltipMessage )
            input.title = this.invalidTooltipMessage;
    }

    if( td.previousSibling && this.value[ td.previousSibling.firstChild.dayIdx ] == null )
        classes.push( "errorLeft" );

    if (this.readOnly)
        classes.push("readOnly")

    td.className = classes.length == 0 ? null : classes.join(" ");

    if( this.headTrEl )
    {
        var th = this.headTrEl.children[ input.cellIdx ];
        th.className = value == null ? "error" : null;
    }
};

WorkdayDurationsEditor.prototype.setInputDisabled = function( disabled )
{
    if( !this.inputs )
        return;
    // ie9 has bug so we have to disable text selection on parent element (see bug #45351)
    for( var i = 0; i < this.inputs.length; i++ )
    {
        this.inputs[i].disabled = disabled;
        var input = $( this.inputs[i] );
        if( disabled )
        {
            input.addClass( "disabled" );
            disableTextSelection( this.inputs[i] );
            disableTextSelection( input.parent().get( 0 ) );
        }
        else
        {
            input.removeClass( "disabled" );
            enableTextSelectionBack( this.inputs[i] );
            enableTextSelectionBack( input.parent().get( 0 ) );
        }
    }
};

WorkdayDurationsEditor.sumDurations = function( durations )
{
    var sum = 0;
    for( var i = 0; i < durations.length; i++ )
        sum += durations[i];
    return sum;
};

WorkdayDurationsEditor.prototype.getInputs = function()
{
    return this.inputs;
};

export default WorkdayDurationsEditor



// WEBPACK FOOTER //
// ./web/js/controls/WorkdayDurationsEditor.js